<!-- 업체 선택용 공통 팝업 -->
<template>

  <v-container fluid>
    <v-row align="center" justify="center">
        <v-col cols="8" class="pa-0">
            <v-text-field 
              v-model="eventname" dense disabled
              :placeholder="$t('devicedialog_msg1')"
              outlined height="43"
              color="#808080"
              hide-details
              />
        </v-col>
        <v-col cols="4" class="pa-0" align="center">
            <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="showpopup_com" >{{$t('common_select')}}</v-btn>
        </v-col>
    </v-row>   

    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" max-width="940px">
        <v-card class="dialog_round pa-5">
          
            <v-row justify="space-between">
              <v-col align="start" cols="12" md="6" sm="6" xs="6">
                <span class="ml-10 dialog_title">{{$t('devicedialog_msg2')}}</span>
              </v-col>
              <v-col align="end" cols="12" md="6" sm="6" xs="6">
                <v-btn class="dialog_btn mr-10" rounded large @click="clear_com">{{$t('common_selectcancel')}}</v-btn>
              </v-col>
            </v-row>
          
          <v-row dense justify="center">
            <v-col cols="11">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col md="10" sm="10" xs="10">
                  <v-text-field 
                    dense single-line clearable
                    @keyup.enter="search_run_com" 
                    v-model="search_keyword_com" 
                    :placeholder="$t('common_search_holder')"
                    outlined height="43"
                    color="#808080"
                    hide-details
                    />
                </v-col>
                <v-col md="2" sm="2" xs="2">
                  <v-btn width="100%" class="search_btn_freesize" elevation="0" outlined large @click="search_run_com">{{$t("common_search")}}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-data-table
                    ref="table"
                    :headers="headers_com"
                    :items="itemList_com"
                    v-model="select_com"
                    :no-data-text="$t('devicedialog_msg3')"
                    hide-default-footer
                    class="datatablestyle"
                    :items-per-page="pagerow_com"
                    item-key="IDX"
                    >
                    <template v-slot:header.ACCNT>
                      <a :class="sort_name_com=='ACCNT'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('ACCNT')">{{$t('deviceadmin_col1')}}</a>
                    </template>
                    <template v-slot:header.DESC>
                      <a :class="sort_name_com=='DESC'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('DESC')">{{$t('deviceadmin_col6')}}</a>
                    </template>
                    <template v-slot:header.COM_NAME>
                      <a :class="sort_name_com=='COM_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('COM_NAME')">{{$t('deviceadmin_col9')}}</a>
                    </template>

                    <template v-slot:item.ACCNT="{ item }">
                      <a @click="select_func(item)">{{item.ACCNT}}</a>
                    </template>
                    
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" class="d-flex justify-center">
                  <v-btn v-if="bottompage_com > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
                  <span v-for="n in subpage_com" :key="n.id">
                      <span v-if="page_com == bottompage_com-1+n">
                          <v-btn color="red" icon small @click="loadpage_com(bottompage_com-1+n)">{{bottompage_com-1+n}}</v-btn>
                      </span>
                      <span v-else>
                          <v-btn icon small @click="loadpage_com(bottompage_com-1+n)">{{bottompage_com-1+n}}</v-btn>
                      </span>
                  </span>
                  <v-btn v-if="subpage_com == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="close_com">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>     
    </v-row>
    
  </v-container>

</template>

<script>
    export default {
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
            eventname: String,
            comidx: Number,
        },

        data: ()=> ({
            dialog_com : false,
            load_flag : false,
            headers_com: [
              {text: '장비명', value: 'ACCNT', sortable: false, align:'center', width:"40%"},
              {text: '상세위치', value: 'DESC', sortable: false, align:'center'},
              {text: '로그인기업', value: 'COM_NAME', sortable: false, align:'center' },
            ],

            sort_name_com: 'ACCNT',
            sort_type_com: true,    //true : DESC, false: ASC

            itemList_com: [],
            select_com:[],
            search_keyword_com : '',
            totalcnt_com : 0,      //전체 아이템 개수
            page_com : 0,
            maxpage_com : 0,       //전체 페이지 개수
            startpage_com: 1,      //시작 인덱스
            bottompage_com : 1,    //하단 페이징 번호의 시작점을 계산하기 위한 변수
            subpage_com : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
            pagerow_com : 15,      //한 페이지에 보여줄 row수
            
        }),

        updated(){
          if(this.dialog_com){
            if(!this.load_flag && this.itemList_com.length == 0 && this.search_keyword_com.length == 0){
              this.load_flag = false;
              this.loadpage_com(1);
            }
          }else{
            this.load_flag = false;
          }

        },



        methods: {
            customsort_com(sortname){
              this.sort_name_com = sortname;
              this.sort_type_com = !this.sort_type_com;
              this.loadpage_com(this.page_com);
            },

            // eslint-disable-next-line no-unused-vars
            visibilityChanged (isVisible, entry) {
              
            },

            prev_com(){
                this.bottompage_com = this.bottompage_com - 10 >= 1 ? this.bottompage_com - 10 : 1;
                this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
                var temp_page = this.bottompage_com + this.subpage_com - 1; //이전을 누르면 가장 끝 번호 선택
                this.loadpage_com(temp_page);
            },
            next_com(){
                this.bottompage_com = this.bottompage_com + 10 <= this.maxpage_com ? this.bottompage_com + 10 : this.maxpage_com;
                this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
                var temp_page = this.bottompage_com;
                this.loadpage_com(temp_page);
            },

            makepaging_com(){
                var div1 = this.totalcnt_com / this.pagerow_com; 
                var div2 = this.totalcnt_com % this.pagerow_com;
                if(div2 == 0){  
                    this.maxpage_com = parseInt(div1);    
                }else{
                    this.maxpage_com = parseInt(div1+1);
                }
                if(this.bottompage_com == 1){
                this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
                }
            },

            search_run_com(){
                this.loadpage_com(1);
            },

            loadpage_com(p){

                this.page_com = p;
                this.$http.post(this.$host+'/api/KioskList',{
                      search_keyword: this.search_keyword_com == null || this.search_keyword_com == undefined ?  '' : escape(this.search_keyword_com)
                    , sort_name:this.sort_name_com
                    , sort_type: this.sort_type_com==true ? "DESC" : "ASC" 
                    , page: this.page_com
                    , pagerow: this.pagerow_com
                    , ADMIN_IDX: this.$session.get("ADMIN_IDX")
                    , COM_IDX: this.comidx
                    , LAN_CODE:this.$i18n.locale
                },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
                .then((result)=>{
                    if(result.data.resultCode == 0){
                        
                        this.load_flag = true;

                        //토큰 저장
                        if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                          this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                        }
                        if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                          this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                        }

                        this.totalcnt_com = result.data.totalcnt;
                        this.makepaging_com();
                        const list = result.data.resultData;
                        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                        list.forEach(element => {
                            this.itemList_com.push(element); 
                        });

                  }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                    
                });

            },

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                this.search_keyword_com = '';
            },

            //선택 초기화
            clear_com () {
                this.$emit('callback', {NAME:'', IDX:''})
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                this.search_keyword_com = '';
            },
            
            //선택
            select_func(select_item){
              this.$emit('callback', select_item)
              //콜백 호출 후 닫아야함.
              this.dialog_com = false
              this.select_com = [];
              this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
              this.search_keyword_com = '';
            },

            showpopup_com(){
                if(this.comidx == null){
                  this.$alert(this.$t('eventdialog_msg4'));
                  return;
                }
                this.dialog_com = true;
                this.load_flag = false;
            },

            


        }

    }
</script>

<style scoped>

</style>